import { api } from '@api'

export const getCurrentSetupChannel = async (id: string) => {
	const { data, error } = await api()
		.from('channel')
		.select('*')
		.eq('name', id)
		.maybeSingle()

	if (error) {
		console.error(error)
		throw new Error(error.message)
	}

	return data
}
